"use client"

import { AddToCalendarButton } from "@/app/components/add-to-calendar/add-to-calendar-button"
import { DropPageType, useDropPageHref } from "@/app/navigation/drop"
import type { MinimalDrop } from "@anaconda/core/drop/types"
import { Trans, useLingui } from "@lingui/react/macro"
import type { ButtonProps } from "@rarible_int/anaconda_ui_components"
import { useEffect, useMemo, useState } from "react"

interface Props extends Omit<ButtonProps, "onClick" | "children"> {
  drop: MinimalDrop
}

export function AddDropToCalendarButton({ drop, ...props }: Props) {
  const relativeUrl = useDropPageHref(drop.id, DropPageType.OVERVIEW)
  const [absoluteUrl, setAbsoluteUrl] = useState<string>(relativeUrl)
  const { t } = useLingui()

  useEffect(() => {
    setAbsoluteUrl(window.location.origin + relativeUrl)
  }, [relativeUrl])

  const eventAttributes = useMemo(() => {
    if (!drop.phases) {
      return null
    }

    const endDate = drop.phases[0].endDate
      ? new Date(drop.phases[0].endDate)
      : addHours(new Date(drop.phases[0].startDate), 1)

    return {
      title: t`${drop.title} Mint`,
      description: t`${drop.title} Mint is live on Rarible`,
      startDate: new Date(drop.phases[0].startDate),
      endDate,
      url: absoluteUrl,
    }
  }, [drop, absoluteUrl, t])

  return (
    <>
      {eventAttributes && (
        <AddToCalendarButton eventAttributes={eventAttributes} {...props}>
          <Trans>Add to Calendar</Trans>
        </AddToCalendarButton>
      )}
    </>
  )
}

function addHours(date: Date, hours: number) {
  return new Date(date.getTime() + hours * 60 * 60 * 1000)
}
